import { subWeeks, startOfWeek, endOfWeek, subDays, startOfMonth, subMonths, endOfMonth, addDays, } from "date-fns/fp";
import { pipe } from "ramda";
export const today = new Date();
export const yesterday = {
    start: subDays(1)(today),
    end: subDays(1)(today),
};
export const lastBusinessWeek = {
    start: pipe(subWeeks(1), startOfWeek, addDays(1))(today),
    end: pipe(subWeeks(1), endOfWeek, subDays(1))(today),
};
export const lastWeek = {
    start: pipe(subWeeks(1), startOfWeek)(today),
    end: pipe(subWeeks(1), endOfWeek)(today),
};
export const lastMonth = {
    start: pipe(subMonths(1), startOfMonth)(today),
    end: pipe(subMonths(1), endOfMonth)(today),
};
//# sourceMappingURL=dates.js.map